var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('TopBar',{staticClass:"white",attrs:{"clipped-left":""}}),(_vm.isLoggedIn)?_c('v-navigation-drawer',{attrs:{"app":"","clipped":"","permanent":"","dark":"","color":"secondary"}},[_c('PrimaryNavigation')],1):_vm._e(),_c('v-main',[(_vm.isLoggedIn)?_vm._t("default"):_c('Login')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }